module.exports = __webpack_public_path__ + "media/bootstrap-icons/badge-ar-fill-c5467ae5.svg";